import { motion } from "framer-motion";
import { Swords, Coins, ShieldCheck, Users } from "lucide-react";

const CARDS = [
  {
    icon: Swords,
    title: "Player vs Player",
    body: "You compete against real players, never the house. Arena Platform never takes a position against you.",
    accent: "text-[#FF3B30]",
    border: "border-[#FF3B30]/30",
    span: "md:col-span-7",
    testid: "about-card-pvp",
  },
  {
    icon: Coins,
    title: "Prize Pool, Not House Pay-out",
    body: "Every entry fee feeds a transparent on-chain pool. Winners are paid from the pool — operator carries zero liability.",
    accent: "text-[#39FF14]",
    border: "border-[#39FF14]/30",
    span: "md:col-span-5",
    testid: "about-card-pool",
  },
  {
    icon: ShieldCheck,
    title: "Locked 8% Commission",
    body: "Platform commission is fixed at 8% — and drops to 7% when the tournament creator wins. No hidden spreads, no manipulated odds.",
    accent: "text-[#00F0FF]",
    border: "border-[#00F0FF]/30",
    span: "md:col-span-5",
    testid: "about-card-commission",
  },
  {
    icon: Users,
    title: "A Whole Suite of Software",
    body: "Arena is not one app — it's a series of competitive multiplayer titles. ARC is the universal currency that connects all of them.",
    accent: "text-white",
    border: "border-white/15",
    span: "md:col-span-7",
    testid: "about-card-suite",
  },
];

export default function AboutArena() {
  return (
    <section id="about" className="relative py-24 sm:py-32" data-testid="about-section">
      <div className="absolute inset-0 bg-grid-dense opacity-30 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#39FF14]">// the protocol</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black mt-2">
            What is the <span className="glow-cyan text-[#00F0FF]">Arena Platform</span>?
          </h2>
          <p className="mt-5 text-white/70 text-base sm:text-lg font-mono leading-relaxed">
            A series of software products for online platforms running PvP multiplayer betting
            tournaments. No house edge, no operator risk — just real player skill, real pools,
            real settlement.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 lg:gap-6">
          {CARDS.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className={`glass p-7 sm:p-8 ${c.span} ${c.border} relative overflow-hidden group`}
              data-testid={c.testid}
            >
              <div className="absolute -top-10 -right-10 opacity-[0.06] group-hover:opacity-[0.1] transition">
                <c.icon className={`w-44 h-44 ${c.accent}`} strokeWidth={1} />
              </div>
              <c.icon className={`w-7 h-7 ${c.accent} mb-5`} />
              <h3 className="font-display text-xl sm:text-2xl font-bold mb-3">{c.title}</h3>
              <p className="text-white/65 font-mono text-sm leading-relaxed max-w-md">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
